import React from 'react';

export default function FileIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.66668 0.666687H1.66668C0.933344 0.666687 0.34001 1.26669 0.34001 2.00002L0.333344 10C0.333344 10.7334 0.933344 11.3334 1.66668 11.3334H12.3333C13.0667 11.3334 13.6667 10.7334 13.6667 10V3.33335C13.6667 2.60002 13.0667 2.00002 12.3333 2.00002H7.00001L5.66668 0.666687Z"
                fill="#9196A1"
            />
        </svg>
    );
}
